module.exports = __webpack_public_path__ + "img/image3.70caaa0d.jpg";